// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trial-expired-modal__text[data-v-1d253935]{font-size:14px}.trial-expired-modal__accent[data-v-1d253935]{font-size:13px;color:#fff;background-color:#e763ae;border-radius:8px;padding:12px 16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
